import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { useDataGridCommonStyles } from '~/components/SolaForceDataGrid/hooks/useDataGridCommonStyles';
import {
  UseAddWorklistTasksTableProps,
  useAddWorklistTasksTable,
} from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/AddWorklistDialog/AddWorklistTasksTable/useAddWorklistTasksTable';
import { useSxStyles } from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/AddWorklistDialog/AddWorklistTasksTable/useStyles';
import { EditWorklistTaskDialog } from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/EditWorklistTaskDialog';
import { mergeSxProps } from '~/utils/helpers/sxProps';

export const AddWorklistTasksTable = (props: UseAddWorklistTasksTableProps) => {
  const { t } = useTranslation();

  const sxStyles = useSxStyles();

  const { dataGridProps, editTaskProps, customTasks } =
    useAddWorklistTasksTable(props);
  const { autoRowHeightPadding } = useDataGridCommonStyles();

  return (
    <>
      <Box sx={sxStyles.container}>
        <DataGridPro
          {...dataGridProps}
          hideFooter={true}
          autoHeight={true}
          getRowId={(row) => row.taskId ?? -1}
          density={'compact'}
          getRowHeight={() => 'auto'}
          sx={mergeSxProps(sxStyles.dataGrid, autoRowHeightPadding)}
        />
      </Box>
      {customTasks.enabled && (
        <Button onClick={() => customTasks.onAddNewTask()} fullWidth={true}>
          {t('addTask')}
        </Button>
      )}
      {editTaskProps.open && <EditWorklistTaskDialog {...editTaskProps} />}
    </>
  );
};
